<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faNotebook"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">
                Overview
                <font-awesome-icon widthAuto :icon="faTelescope"></font-awesome-icon>
            </h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                <template v-if="props.templateView">
                    Snippet Templates are Snippets that can be shared with Groups. This allows you to draft resuable Snippets that individual Groups can make use of in their Campaigns and Quick Blast messages.
                </template>
                <template v-else>
                    Snippets are reusable pieces of content that bring speed and consistency to the message creation process. Use them in places like Message Hub, Campaigns, Quick Blast or anywhere you write messages.
                </template>
            </p>
            <a :href="docsLink"
               target="_blank"
               rel="noopener noreferrer"
               class="text-sm font-sans font-normal text-sky-500 underline lg:text-base">
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2"
                                   :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup>
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { faTelescope, faNotebook } from '@fortawesome/pro-regular-svg-icons';

const props = defineProps({
    templateView: {
        type: Boolean,
        default: false,
    }
});

const docsLink = props.templateView ?
    'https://explore.voxie.com/voxiesupport/hc/en-us/articles/snippet-templates' :
    'https://explore.voxie.com/voxiesupport/hc/en-us/articles/snippets';
</script>
